// extracted by mini-css-extract-plugin
export default {"Pagination":"index__Pagination__IaVDW","Filters":"index__Filters__SF1cq"};